import './index.scss';

const Spinner = () => {
  return (
    <div className="center">
      <div className="spinner"></div>
    </div>
  );
};

export default Spinner;
